"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _TopicVoteCount = require("@insided/destination/uikit/TopicVoteCount");

var TopicLikeButtonView = function TopicLikeButtonView(_ref) {
  var count = _ref.count,
      hasVoted = _ref.hasVoted,
      onClick = _ref.onClick;
  return (0, _preact.h)("div", null, (0, _preact.h)(_TopicVoteCount.TopicLikeButton, {
    hasVoted: hasVoted,
    onClick: onClick
  }, (0, _preact.h)(_TopicVoteCount.TopicVoteCountWrapper, null, (0, _preact.h)(_TopicVoteCount.VoteCountInner, {
    count: count,
    className: "thread-meta-item__text"
  }))));
};

var _default = TopicLikeButtonView;
exports.default = _default;